module.exports = __webpack_public_path__ + "static/media/onboarding-welcome.7090a37c.png";